import { createContext, useContext } from "react";

export interface ThreadContext {
  userName: string | null;
  userAvatar: string | null;
  threadId: string | undefined;
}

export const ThreadContext = createContext<ThreadContext>({
  userName: null,
  userAvatar: null,
  threadId: undefined,
});

export const useThreadContext = () => {
  return useContext(ThreadContext);
};
